import { render, staticRenderFns } from "./saList.vue?vue&type=template&id=88af55c6"
import script from "./saList.vue?vue&type=script&lang=js"
export * from "./saList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports